/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  danger,
  success,
  useCustomForm,
  useEffect,
  useNavigate,
  useParams,
} from "@";
import { useLandingPageQuery } from "../api/queries/index";
import { useSaveLandingPageMutation } from "../api/mutations/index";
import { defaultValues, schema } from "../lib/validation";
import type { LandingPage, LandingPageFormValues } from "../types";

interface UseLandingPageFormReturn {
  register: any;
  watch: any;
  setValue: any;
  getValues: any;
  control: any;
  errors: any;
  handleSubmit: (
    fn: () => Promise<void>,
  ) => (e?: React.BaseSyntheticEvent) => Promise<void>;
  isSubmitting: boolean;
  edit: string | undefined;
  show: string | undefined;
  isViewMode: boolean;
  error: Error | null;
  links: { name: string; link: string }[];
  submit: () => Promise<void>;
}

export const useLandingPageForm = (): UseLandingPageFormReturn => {
  const navigate = useNavigate();
  const { edit, show } = useParams();
  const id = edit || show;

  const { data: page, error: pageError } = useLandingPageQuery(id);
  const saveLandingPageMutation = useSaveLandingPageMutation();

  const {
    reset,
    watch,
    errors,
    control,
    setValue,
    register,
    getValues,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(defaultValues, schema);

  useEffect(() => {
    if (page) {
      reset({
        id: page.id,
        name: page.name || "",
        slug: page.slug || "",
        seoTitle: page.seoTitle || "",
        seoDescription: page.seoDescription || "",
        projectId: page.projectId ?? null,
        themeId: page.themeId ?? null,
      } as LandingPage);
    }
  }, [page, reset]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      danger("يوجد خطأ في البيانات المدخلة");
    }
  }, [errors]);

  const submit = async () => {
    try {
      await saveLandingPageMutation.mutateAsync(
        getValues() as LandingPageFormValues,
      );
      await success("تم الحفظ بنجاح");
      navigate("/website/landing-pages");
    } catch (err) {
      console.log("submit landing-page error:", err);
    }
  };

  const links = [
    { name: "صفحات الهبوط", link: "/website/landing-pages" },
    { name: edit ? "تعديل" : show ? "عرض" : "اضافة", link: "" },
  ];

  return {
    register,
    watch,
    setValue,
    getValues,
    control,
    errors,
    handleSubmit,
    isSubmitting,
    edit,
    show,
    isViewMode: !!show,
    error: pageError as Error | null,
    links,
    submit,
  };
};
